import { lazy } from "react";
// import DashboardLayout from "./layouts/DashboardLayout";
import LoginLayout from "./layouts/LoginLayout";
import DashBoardLayOut from "../src/layouts/DashBoardLayOut/index.js";

export const routes = [
  {
    exact: true,
    auth: false,
    path: "/",
    layout: LoginLayout,
    component: lazy(() => import("./views/pages/Auth/Login.jsx")),
  },
  {
    exact: true,
    auth: false,
    path: "/forgot",
    layout: LoginLayout,
    component: lazy(() => import("./views/pages/Auth/ForgotPassword.js")),
  },
  {
    exact: true,
    auth: false,
    path: "/otpVerification",
    layout: LoginLayout,
    component: lazy(() => import("./views/pages/Auth/OTPVerification.js")),
  },
  {
    exact: true,
    auth: false,
    path: "/resetPassword",
    layout: LoginLayout,
    component: lazy(() => import("./views/pages/Auth/ResetPassword.js")),
  },
  {
    exact: true,
    auth: true,
    path: "/dashboard",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/DashboardMain/LandingPage.js")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/patient-management",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/Patient/PatientListing.jsx")
    ),
  },

  {
    exact: true,
    auth: true,
    path: "/patient-management/patient",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/Patient/PatientView.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/patient-management/patient/patient-details",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/Patient/PatientDetails.jsx")
    ),
  },
  {
    exact: true,
    auth: true,
    path: "/settings",
    layout: DashBoardLayOut,
    component: lazy(() =>
      import("./views/pages/Dashboard/Settings/profile.jsx")
    ),
  },
  
];
